// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__3_1Ll","scribble":"scribble__2pvws","svgWhite":"svgWhite__m3_K2","svgBlack":"svgBlack__1RLio"};


//////////////////
// WEBPACK FOOTER
// ./components/logo/styles.scss
// module id = 1cu/
// module chunks = 1